import { Transaction } from "@mysten/sui/transactions";
import { doubleAssetPoolCoinMap, poolInfo } from "../common/maps.js";
import { withdrawCetusAlphaSuiTxb, withdrawCetusSuiTxb, withdrawCetusTxb, } from "./cetus.js";
import { withdrawBluefinFungibleTxb, withdrawBluefinStsuiTxb, withdrawBluefinSuiFirstTxb, withdrawBluefinSuiSecondTxb, withdrawBluefinType1Txb, withdrawBluefinType2Txb, } from "./bluefin.js";
import { naviWithdrawTx } from "./navi.js";
import { bucketWithdrawTx } from "./bucket.js";
import { getInvestor, getPoolExchangeRate, } from "../sui-sdk/functions/getReceipts.js";
import { loopingWithdraw } from "./navi-looping.js";
import { getEstimatedGasBudget, getLiquidity } from "./deposit.js";
import { alphalendLoopingWithdraw, alphalendSingleLoopWithdraw, } from "./alphalend.js";
import { Decimal } from "decimal.js";
export async function withdrawTxb(xTokensAmount, poolName, address) {
    let txb = new Transaction();
    if (poolInfo[poolName].parentProtocolName === "CETUS") {
        const coin1 = doubleAssetPoolCoinMap[poolName].coin1;
        const coin2 = doubleAssetPoolCoinMap[poolName].coin2;
        if (coin1 === "CETUS" && coin2 === "SUI") {
            txb = await withdrawCetusSuiTxb(xTokensAmount, poolName, {
                address,
            });
        }
        else if (coin2 === "SUI") {
            txb = await withdrawCetusAlphaSuiTxb(xTokensAmount, poolName, {
                address,
            });
        }
        else {
            txb = await withdrawCetusTxb(xTokensAmount, poolName, {
                address,
            });
        }
    }
    else if (poolInfo[poolName].parentProtocolName === "BLUEFIN") {
        const coin1 = doubleAssetPoolCoinMap[poolName].coin1;
        const coin2 = doubleAssetPoolCoinMap[poolName].coin2;
        if (poolName === "BLUEFIN-FUNGIBLE-STSUI-SUI") {
            txb = await withdrawBluefinFungibleTxb(xTokensAmount, poolName, {
                address,
            });
        }
        else if (poolName === "BLUEFIN-NAVX-VSUI" ||
            poolName === "BLUEFIN-ALPHA-USDC" ||
            poolName === "BLUEFIN-BLUE-USDC") {
            txb = await withdrawBluefinType2Txb(xTokensAmount, poolName, {
                address,
            });
        }
        else if (coin1 === "SUI") {
            txb = await withdrawBluefinSuiFirstTxb(xTokensAmount, poolName, {
                address,
            });
        }
        else if (coin2 === "SUI") {
            txb = await withdrawBluefinSuiSecondTxb(xTokensAmount, poolName, {
                address,
            });
        }
        else if (coin1 === "STSUI" || coin2 === "STSUI") {
            txb = await withdrawBluefinStsuiTxb(xTokensAmount, poolName, {
                address,
            });
        }
        else {
            txb = await withdrawBluefinType1Txb(xTokensAmount, poolName, {
                address,
            });
        }
    }
    else if (poolInfo[poolName].parentProtocolName === "NAVI") {
        if (poolInfo[poolName].strategyType === "LOOPING") {
            txb = await loopingWithdraw(poolName, xTokensAmount, { address });
        }
        else
            txb = await naviWithdrawTx(xTokensAmount, poolName, { address });
    }
    else if (poolInfo[poolName].parentProtocolName === "BUCKET") {
        txb = await bucketWithdrawTx(xTokensAmount, { address });
    }
    else if (poolInfo[poolName].parentProtocolName === "ALPHALEND") {
        if (poolInfo[poolName].strategyType === "LOOPING") {
            txb = await alphalendLoopingWithdraw(poolName, xTokensAmount, {
                address,
            });
        }
        else if (poolInfo[poolName].strategyType === "SINGLE-LOOPING") {
            txb = await alphalendSingleLoopWithdraw(poolName, xTokensAmount, {
                address: address,
            });
        }
    }
    txb.setSender(address);
    const estimatedGasBudget = await getEstimatedGasBudget(txb, address);
    if (estimatedGasBudget)
        txb.setGasBudget(estimatedGasBudget);
    return txb;
}
export async function coinAmountToXTokensSingleAsset(amount, poolName) {
    const exchangeRate = await getPoolExchangeRate(poolName, true);
    const xTokens = Math.floor(parseFloat(amount) / exchangeRate.toNumber());
    return xTokens.toString();
}
export async function coinAmountToXTokensDoubleAsset(amount, poolName, isAmountA) {
    const liquidity = await getLiquidity(poolName, isAmountA, amount);
    let liquidityAmount = liquidity.liquidityAmount.toString();
    if (poolInfo[poolName].strategyType === "LEVERAGE-YIELD-FARMING") {
        let investor = (await getInvestor(poolName, true));
        liquidityAmount = new Decimal(liquidityAmount)
            .div(new Decimal(1).minus(new Decimal(investor.content.fields.current_debt_to_supply_ratio.fields.value).div(1e18)))
            .toString();
    }
    const exchangeRate = await getPoolExchangeRate(poolName, true);
    let xTokens = new Decimal(liquidityAmount).div(exchangeRate);
    return xTokens.floor().toString();
}
//# sourceMappingURL=withdraw.js.map